import React from "react";
import styles from "./MyBigSpinner.module.scss"; 

const MyBigSpinner = () => {
  return (
    <div className={styles.fullPageSpinner}>
      <div className={styles.spinnerInner}></div>
    </div>
  );
};

export default MyBigSpinner;
